// extracted by mini-css-extract-plugin
export default {"social_links":"SocialLinks_social_links__PsxSH","icon":"SocialLinks_icon__61Flb"};